import apiCalls from "../config/apiCalls";
import headers from "../config/headers";
import localStorageFunc from "./localStorageFunc";

const getSavedAddress = (data) => {
    try {
        apiCalls.GET_SAVED_ADDRESS({
            headers: headers(),
            payload: data
        }).then((response) => {
            if(response?.data) {
                const res = response.data;
                localStorageFunc.setUserAddress(res.data);
            }
        }).catch((error) => {
            console.error('ERROR: getSavedAddress', error);
        })
    }
    catch (error) {
        console.error('ERROR: unable to get user address: ', error);
    }
};

export default {
    getSavedAddress
};
